<script>
import { mapGetters, mapActions } from "vuex";
import Multiselect from "vue-multiselect";
import { debounce } from "../../../state/helpers";
import { formatIST } from "../../../config/moment";
import { chargingHistoryService } from "../../../helpers/chargingHistoryService";

import config from "../../../config/config";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";
// import { param } from "express/lib/request";
/**
 * Add-product component
 */

export const OCPP = "OCPP";
export const BLE = "BLE";
export default {
  data() {
    return {
      config: config,
      sortBy: "id",
      perPages: 5,
      sortDesc: true,
      page: 1,
      paginations: {},
      limit: 10,
      search: "",
      formatIST,
      id: "",
      booking: {
        is_cancel: [],
      },
      typeform: {
        selectedCharger: { id: 0, name: "All" },
        selectedType: { id: 0, name: "All" } // Changed from selectedManager to selectedType
      },
      chargerList: [{ id: 0, name: "All" }],
      typeList: [ // Changed from managerList to typeList
        { id: 0, name: "All" },
        { id: 1, name: "Residential" },
        { id: 2, name: "Hub" }
      ],
      charger_station_data: {},
      searchData: debounce(() => {
        this.getChargingHistories();
        this.init = false;
      }, 500),
      fields: [
        {
          key: "id",
          sortable: true,
          label: "#",
        },
        {
          key: "station",
          sortable: true,
          label: "Charging Stations",
        },
        {
          key: "users",
          sortable: true,
          label: "User",
        },
        {
          key: "start_time",
          sortable: true,
          label: "Charging Start Time",
        },
        {
          key: "end_time",
          sortable: true,
          label: "Charging End Time",
        },
        {
          key: "charging_unit",
          sortable: true,
          label: "Charging Unit",
        },
        {
          key: "status",
          sortable: false,
          label: "Status",
        },
        {
          key: "reasons",
          sortable: false,
          label: "Reasons",
        },
        {
          key: "info",
          sortable: false,
          label: "Info",
        },
      ],
      dateRange: {
        startDate: moment().startOf("day").subtract(29, "days"),
        endDate: moment(),
      },
      filters: {
        start_date: moment().startOf("day").subtract(29, "days").format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
      },
      moment: moment,
    };
  },
  props: ["userId"],
  components: { Multiselect, DateRangePicker },
  validations: {},
  computed: {
    ...mapGetters("history", [
      "getAllChargingHistory",
      "loading",
      "chargingHistoryCount",
      "pagination",
      "getAllChargers",
    ]),
    ...mapGetters("booking", ["getAllBookingInfo"]),
  },
  mounted() {

    this.getChargingHistories();
    this.fetchChargersByUser();   // ← swap in your new function
  },
  watch: {
    // whenever the selectedType.id changes, re-fetch chargers
    'typeform.selectedType.id': {
      handler(newId, oldId) {
        // only refetch if it's actually changed
        if (newId !== oldId) {
          this.fetchChargersByUser();
        }
      },
      immediate: false  // you already call it once in mounted()
    }
  },
  methods: {
    ...mapActions("history", ["getChargingHistory", "getCharger"]),
    ...mapActions("booking", ["getBooking"]),
    async fetchChargersByUser() {
      try {
        // 1) Prepare payload
        const payload = { "user_id": this.typeform.selectedType.id };

        // 2) Ensure auth header is set
        // const token = JSON.parse(localStorage.getItem("token"));
        // window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        // 3) Call your existing service (or axios directly)
        const response = await chargingHistoryService.getChargersByUserId(payload);
        const chargers = response.data;
        // 4) Map into the format your <multiselect> expects
        this.chargerList = chargers.map(item => ({
          id: item.id,
          name: item.name,
        }));
      } catch (error) {
        console.error("Failed to fetch chargers by user:", error);
        this.$bvToast.toast('Could not load chargers', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
    },
    async getChargingHistories(page = 1) {
      try {
        const filters = {
          search: this.search,
          sortBy: this.sortBy,
          orderBy: this.sortDesc ? "desc" : "asc",
          page: page && page > 0 ? page : 1,
          perPages: this.perPages,
        };

        if (this.charger_station_data) {
          filters.charger_station_id = this.charger_station_data.id;
        }

        if (this.typeform.selectedType && this.typeform.selectedType.id > 0) {
          filters.user_id = this.typeform.selectedType.id;
        }

        await this.getChargingHistory(filters);

        // Show info message if no results
        if (this.getAllChargingHistory.length === 0) {
          this.$bvToast.toast('No charging history found for selected filters', {
            title: 'Information',
            variant: 'info',
            solid: true,
            autoHideDelay: 3000
          });
        }

      } catch (error) {
        console.error("Error:", error);
        // Only show error for actual failures, not empty results
        if (error.response && error.response.status !== 200) {
          this.$bvToast.toast('Failed to load charging history', {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
        }
      }
    },

    searchUser() {
      this.searchData();
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      if (this.charger_station_data.id > "0") {
        this.searchChargerStation(this.charger_station_data);
      } else {
        this.getChargingHistories();
      }
    },
    searchChargerStation(selectedItems) {
      let page = 1;
      var data = {
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPages: this.perPages,
        charger_station_id: selectedItems.id,
      };
      this.charger_station_data = selectedItems;
      this.getChargingHistory(data);
    },
    getBookingInfo(booking_id) {
      var data = {
        id: booking_id,
      };
      this.getBooking(data).then(() => {
        this.$bvModal.show("bv-modal-booking-info");
      });
    },
    resetForm() {
      this.$v.$reset();
    },
    updateValues(date) {
      const startDate = moment(date.startDate).format("YYYY-MM-DD");
      const endDate = moment(date.endDate).add(1, "days").format("YYYY-MM-DD"); // Include full end date

      // Update internal filter state
      this.filters = {
        ...this.filters,
        start_date: startDate,
        end_date: endDate,
      };

      // Construct the download URL and trigger it
      const downloadUrl = `${this.config.appurl}download-charging-history-data/${startDate}/${endDate}`;
      window.open(downloadUrl, "_blank");
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12">
      <form action="#" @submit.prevent="typeForm">
        <div class="card details-profile-main date-picker-space">
          <div class="card-body">
            <!-- Title Row with Button -->
            <div class="row align-items-center mb-3">
  <div class="col-md-12">
    <div class="pb-0 page-title-box d-flex align-items-center justify-content-between icon-main-page">
      
      <!-- Left: Title -->
      <h4 class="card-title m-0">
        Charging History ({{ chargingHistoryCount }})
      </h4>
      
      <!-- Right: Download Button + Date Picker -->
      <div class="d-flex align-items-center">
        <a :href="config.appurl + 'download-charging-history-data'"
           class="btn btn-primary btn-md btn-rounded ml-2">
          Download All Data
        </a>

        <date-range-picker
          ref="picker"
          :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
          :showDropdowns="true"
          :showWeekNumbers="true"
          opens="left"
          v-model="dateRange"
          class="ml-3"
          @update="updateValues"
        >
          <template v-slot:input="picker">
            {{
              moment(picker.startDate.toISOString()).format("DD-MM-YYYY")
            }} - {{
              moment(picker.endDate.toISOString()).format("DD-MM-YYYY")
            }}
          </template>
        </date-range-picker>
      </div>

    </div>
  </div>
</div>



            <!-- Filters Row -->
            <div class="row mb-3">
              <div class="col-md-3 col-sm-6">
                <div class="form-group">
                  <label>Per Page</label>
                  <select class="form-control" v-model="perPages" @change="searchData()">
                    <option value="5" selected>5</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3 col-sm-6">
                <div class="form-group">
                  <label>Charging Stations</label>
                  <multiselect v-model="typeform.selectedCharger" id="ajax" v-bind:disabled="typeform.checkbox"
                    label="name" track-by="name" placeholder="Search By Charger Station" open-direction="bottom"
                    :options="chargerList" :multiple="false" :searchable="true" :internal-search="true"
                    :clear-on-select="true" :close-on-select="true" :max-height="600" :show-no-results="false"
                    :hide-selected="true" @input="searchChargerStation">
                  </multiselect>
                </div>
              </div>
              <div class="col-md-3 col-sm-6">
                <div class="form-group">
                  <label>Type</label>
                  <multiselect v-model="typeform.selectedType" id="type-ajax" label="name" track-by="id"
                    placeholder="Select Type" open-direction="bottom" :options="typeList" :multiple="false"
                    :searchable="false" :internal-search="true" :clear-on-select="true" :close-on-select="true"
                    :max-height="600" :show-no-results="false" :hide-selected="true" @input="searchUser" />
                </div>
              </div>
              <div class="col-md-3 col-sm-6">
                <div class="form-group">
                  <label>Search</label>
                  <div class="search-box">
                    <div class="position-relative">
                      <input type="text" class="form-control" id="search" @input="searchData()" v-model="search"
                        :placeholder="$t('navbar.search.text')" />
                      <i class="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Table Row -->
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <b-table striped hover :items="getAllChargingHistory" :update:sortBy="sortBy"
                    :update:sortDesc="sortDesc" :no-local-sorting="true" @sort-changed="sortingChanged" :fields="fields"
                    :busy="loading" class="upc-booking-table-class">
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>{{ $t(" Loading") }}</strong>
                      </div>
                    </template>
                    <template v-slot:cell(station)="items">
                      {{ items.item.station ? items.item.station : "" }}
                    </template>
                    <template v-slot:cell(users)="items">
                      <RouterLink v-if="items.item.users" :to="{
                        name: 'user-view',
                        params: { id: base64(items.item.user_id) },
                      }">
                        {{ items.item.users }}
                      </RouterLink>
                    </template>
                    <template v-slot:cell(start_time)="items">
                      {{ formatIST(items.item.charging_start_time) }}
                    </template>
                    <template v-slot:cell(end_time)="items">
                      {{ formatIST(items.item.charging_end_time) }}
                    </template>
                    <template v-slot:cell(charging_unit)="items">
                      {{
                        items.item.connector_id !== null
                          ? `${Number(items.item.charged_value / 1000).toFixed(2)} kWh`
                          : items.item.charging_unit
                      }}
                    </template>
                    <template v-slot:cell(reasons)="items">
                      <div class="text-truncate" style="max-width: 200px;" :title="items.item.start_stop_reason">
                        {{ items.item.start_stop_reason ? items.item.start_stop_reason : "-" }}
                      </div>
                    </template>
                    <template v-slot:cell(status)="items">
                      <div class="text-truncate" style="max-width: 200px;" :title="items.item.charging_status">
                        {{ items.item.charging_status ? items.item.charging_status : "-" }}
                      </div>
                    </template>
                    <template v-slot:cell(amount)="items">
                      <span class="badge badge-secondary">Pre Amount:</span>
                      (&#8377;{{ items.item.pre_auth_charge ? items.item.pre_auth_charge : "-" }})<br />
                      <span class="badge badge-secondary">Ref:</span>
                      {{ items.item.pre_auth_transaction_id ? items.item.pre_auth_transaction_id : "-" }}<br />
                      <span class="badge badge-secondary">Final Amount:</span>
                      (&#8377;{{ items.item.final_charge ? items.item.final_charge : "-" }})<br />
                      <span class="badge badge-secondary">Ref:</span>
                      {{ items.item.final_transaction_id ? items.item.final_transaction_id : "-" }}
                    </template>
                    <template v-slot:cell(cancelled_time)="items">
                      {{ formatIST(items.item.cancelled_time) }}
                    </template>
                    <template v-slot:cell(info)="items">
                      <b-button @click="getBookingInfo(items.item.booking_id)"
                        class="btn btn-success btn-sm btn-rounded">
                        <i class="bx bxs-info-circle"></i>
                      </b-button>
                    </template>
                  </b-table>
                  <tr v-if="loading == false && getAllChargingHistory == 0">
                    <td colspan="100%">
                      <h6 align="center">No Charger History Found</h6>
                    </td>
                  </tr>
                </div>
                <div class="row mt-3">
                  <div class="col-md-12">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                      <ul class="pagination pagination-rounded mb-0">
                        <pagination :data="pagination" :limit="limit" @pagination-change-page="getChargingHistories">
                        </pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- Model -->
    <b-modal v-if="getAllBookingInfo" id="bv-modal-booking-info" size="lg" hide-footer @hidden="resetForm">
      <template #modal-title>#{{ getAllBookingInfo.id }} Booking Info
        <span v-if="getAllBookingInfo.booking_type" class="badge badge-pill badge-secondary">{{
          getAllBookingInfo.booking_type.charAt(0).toUpperCase() +
          getAllBookingInfo.booking_type.slice(1)
        }}</span></template>
      <form action="#" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Booking User Name :
                {{
                  getAllBookingInfo.users ? getAllBookingInfo.users.full_name : "User Deleted"
                }}</label>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Email :
                {{
                  getAllBookingInfo.users && getAllBookingInfo.users.email
                    ? getAllBookingInfo.users.email
                    : "-"
                }}</label>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Mobile Number :
                {{
                  getAllBookingInfo.users && getAllBookingInfo.users.mobile_number
                    ? getAllBookingInfo.users.mobile_number
                    : "-"
                }}</label>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Charging Station :
                {{
                  getAllBookingInfo.chargers ? getAllBookingInfo.chargers.name : "Charger Deleted"
                }}</label>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Charging Station Address :
                {{
                  getAllBookingInfo.chargers ? getAllBookingInfo.chargers.address : "User Deleted"
                }}</label>
            </div>
          </div>
          <template v-if="getAllBookingInfo.chargers && getAllBookingInfo.chargers.users">
            <div class="col-sm-4">
              <div class="form-group mb-3">
                <label>Charger Owner Name : {{ getAllBookingInfo.chargers.users.full_name }}</label>
              </div>
            </div>
          </template>
          <template v-if="getAllBookingInfo && getAllBookingInfo.start_time && getAllBookingInfo.end_time">
            <div class="col-sm-4">
              <div class="form-group mb-3">
                <label>Booking Start - Booking End Time : {{ formatIST(getAllBookingInfo.start_time) }} -
                  {{ formatIST(getAllBookingInfo.end_time) }}</label>
              </div>
            </div>
          </template>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Pre Auth Transaction Id :
                {{
                  getAllBookingInfo.pre_auth_transaction_id
                    ? getAllBookingInfo.pre_auth_transaction_id
                    : "-"
                }}</label>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Pre Auth Charge :
                {{
                  getAllBookingInfo.pre_auth_charge ? getAllBookingInfo.pre_auth_charge : "-"
                }}</label>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Final Transaction Id :
                {{
                  getAllBookingInfo.final_transaction_id
                    ? getAllBookingInfo.final_transaction_id
                    : "-"
                }}</label>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Final Charge :
                {{
                  getAllBookingInfo?.chargers?.type === "OCPP"
                    ? getAllBookingInfo?.charging_history?.total_amount
                      ? Number(getAllBookingInfo?.charging_history?.total_amount).toFixed(2)
                      : "-"
                    : getAllBookingInfo?.chargers?.type === "BLE"
                      ? getAllBookingInfo?.final_charge
                        ? Number(getAllBookingInfo.final_charge).toFixed(2)
                        : "-"
                      : "-"
                }}
              </label>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label>Unit Price :
                {{ getAllBookingInfo.unit_price ? getAllBookingInfo.unit_price : "-" }}</label>
            </div>
          </div>
          <template v-if="getAllBookingInfo.charging_history">
            <div class="col-sm-4">
              <div class="form-group mb-3">
                <label>Total Unit Consumed :
                  {{
                    getAllBookingInfo.chargers.type === "OCPP"
                      ? `${Number(getAllBookingInfo.charging_history.charged_value / 1000).toFixed(
                        2
                      )} kWh`
                      : getAllBookingInfo.chargers.type === "BLE"
                        ? getAllBookingInfo.charging_history.charging_unit
                        : ""
                  }}</label>
              </div>
            </div>
          </template>
          <template v-if="
            getAllBookingInfo.charging_history &&
            getAllBookingInfo.charging_history.charging_start_time
          ">
            <div class="col-sm-4">
              <div class="form-group mb-3">
                <label>Charging Start - Charging End Time :
                  {{ formatIST(getAllBookingInfo.charging_history.charging_start_time) }} -
                  {{ formatIST(getAllBookingInfo.charging_history.charging_end_time) }}</label>
              </div>
            </div>
          </template>
          <template v-if="getAllBookingInfo.is_cancel == '1'">
            <div class="col-sm-4">
              <div class="form-group mb-3">
                <label>Refund Amount :
                  {{
                    getAllBookingInfo.refund_amount ? getAllBookingInfo.refund_amount : "-"
                  }}</label>
              </div>
            </div>
          </template>
          <template v-if="getAllBookingInfo.is_cancel == '1'">
            <div class="col-sm-4">
              <div class="form-group mb-3">
                <label>Refund Percentage (%) :
                  {{
                    getAllBookingInfo.refund_percentage ? getAllBookingInfo.refund_percentage : "-"
                  }}</label>
              </div>
            </div>
          </template>
        </div>
        <div class="text-end mt-3">
          <button type="button" @click="
            resetForm();
          $bvModal.hide('bv-modal-booking-info');
          " class="btn btn-light">
            Close</button>&nbsp;
        </div>
      </form>
    </b-modal>
    <!-- Model -->
  </div>
</template>
<style>
/* Add this to your styles */
.upc-booking-table-class {
  font-size: 0.875rem;
  width: 100%;
  table-layout: fixed; /* Changed from auto to fixed for consistent column behavior */
}

.upc-booking-table-class th {
  white-space: nowrap;
  position: sticky; /* Keep headers visible during horizontal scroll */
  top: 0;
  background: white; /* Ensure headers are visible over content */
}

/* Column width definitions */
.upc-booking-table-class th:nth-child(1), 
.upc-booking-table-class td:nth-child(1) {
  width: 5%; /* ID column */
}

.upc-booking-table-class th:nth-child(2), 
.upc-booking-table-class td:nth-child(2) {
  width: 15%; /* Station column */
}

.upc-booking-table-class th:nth-child(3), 
.upc-booking-table-class td:nth-child(3) {
  width: 15%; /* User column */
}

.upc-booking-table-class th:nth-child(4), 
.upc-booking-table-class td:nth-child(4) {
  width: 12%; /* Start Time column */
}

.upc-booking-table-class th:nth-child(5), 
.upc-booking-table-class td:nth-child(5) {
  width: 12%; /* End Time column */
}

.upc-booking-table-class th:nth-child(6), 
.upc-booking-table-class td:nth-child(6) {
  width: 5%; /* Charging Unit column */
}

.upc-booking-table-class th:nth-child(7), 
.upc-booking-table-class td:nth-child(7) {
  width: 10%; /* Status column */
}

.upc-booking-table-class th:nth-child(8), 
.upc-booking-table-class td:nth-child(8) {
  width: 16%; /* Reasons column */
}

.upc-booking-table-class th:nth-child(9), 
.upc-booking-table-class td:nth-child(9) {
  width: 10%; /* Info column */
}

/* Reason column specific styling */
.upc-booking-table-class td:nth-child(8) {
  word-wrap: break-word;
  white-space: normal !important;
  overflow-wrap: break-word;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .upc-booking-table-class {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
  
  .upc-booking-table-class td:nth-child(8) {
    max-width: 150px;
    min-width: 100px;
    font-size: 0.8rem;
  }

  .upc-booking-table-class td {
    padding: 0.3rem;
  }
}

.search-box .form-control {
  padding-left: 40px;
}

.search-box .search-icon {
  position: absolute;
  left: 13px;
  top: 50%;
  font-size: 16px;
  color: #6c757d;
}

.multiselect {
  min-height: 38px;
}

.multiselect__tags {
  min-height: 38px;
  padding: 6px 40px 0 8px;
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
}
/* Add this to your styles */
.upc-booking-table-class {
  font-size: 0.875rem;
  table-layout: auto;
}

.upc-booking-table-class th {
  white-space: nowrap;
}

/* Reason column specific styling */
.upc-booking-table-class td:nth-child(6) {
  /* Adjust the index if your column position changes */
  max-width: 200px;
  min-width: 150px;
  word-wrap: break-word;
  white-space: normal !important;
  overflow-wrap: break-word;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .upc-booking-table-class td:nth-child(6) {
    max-width: 150px;
    min-width: 100px;
    font-size: 0.8rem;
  }

  .upc-booking-table-class td {
    padding: 0.3rem;
  }
}

.search-box .form-control {
  padding-left: 40px;
}

.search-box .search-icon {
  position: absolute;
  left: 13px;
  top: 50%;
  font-size: 16px;
  color: #6c757d;
}

.multiselect {
  min-height: 38px;
}

.multiselect__tags {
  min-height: 38px;
  padding: 6px 40px 0 8px;
}

.table-responsive {
  overflow-x: auto;
}
</style>